<script>
import * as acemodule from 'ace-builds/src-noconflict/ace';
import store from '@state/store'


export default {
    store,
    props: ['editorId', 'content', 'lang', 'theme'],
    data () {
        return {
            editor: Object,
            beforeContent: '',
            rows: 0,
        }
    },
    computed: {
        ticketContent () {
            return this.$store.state.lineCommand.tickets;
        },
        docContent () {
            return this.$store.state.lineCommand.docs;
        },
        // codeContent () {
        //     return this.$store.state.lineCommand.code;
        // }
    },
    watch: {
        content (value) {
            if (this.beforeContent !== value) {
                this.editor.setValue(value, 1)
            }
        },
        rows: function (value){
            this.createLineCommands(value);
        }
    },
    mounted () {
        const lang = this.lang || 'text';
        // const theme = this.theme || 'github'
       // window.ace.config.set('basePath', './node_modules/ace-builds/src');
        this.editor = window.ace.edit(this.editorId)
        this.editor.setOptions({
            autoScrollEditorIntoView: true,
            maxLines: 8,
            showGutter: false
        });
        // this.editor.session.setMode("ace/mode/markdown");
        this.editor.setAutoScrollEditorIntoView(true);
        this.editor.setOption("minLines", 100);
        this.editor.setOption("maxLines", 100);

        // mode-xxx.js or theme-xxx.jsがある場合のみ有効
        // this.editor.setTheme(`ace/theme/${theme}`)

        if(this.editor.session.getLength() === 1) this.createLineCommands(1);


        this.editor.setValue(this.content, 1);

        // todo: can likely remove this entirely
        // this.createLineCommands(this.content.split('\n').length);

        this.editor.on('change', () => {
            const oldRows = this.rows;
            this.rows = this.editor.session.getLength();

            // detect if a row was added:
            if(oldRows < this.rows){
                // shift the markers
                const addedAtRow = this.editor.getCursorPosition().row;
                this.$store.commit('lineCommand/shiftContentMarkers', {'row':addedAtRow+1, 'del':0});
            }else if(oldRows > this.rows){
                // shift the markers
                const addedAtRow = this.editor.getCursorPosition().row;
                this.$store.commit('lineCommand/shiftContentMarkers', {'row':addedAtRow, 'del':1});
            }

            const value =  this.editor.getValue();
            this.$store.commit('lineCommand/setMarkdown',value);
            this.beforeContent = value;
        });
    },
    methods: {
        createLineCommands(rows){
                console.log('createLineCommands',this.ticketContent, this.docContent);
            for(let i = 0; i < rows; i++){
                if(this.ticketContent[i] === undefined) this.$store.commit('lineCommand/addTicket', true);
                if(this.docContent[i] === undefined) this.$store.commit('lineCommand/addDoc', true);
                // if(this.codeContent[i] === undefined) this.$store.commit('lineCommand/addCode', true);
            }
        },
        rightGutter: function(index){
            const top = index * 16;
            const style = "top:"+top+"px;";
            return style;
        },
        toggleTicket: function(index){
            let val = this.ticketContent[index];
            val = !(val);
            this.$store.commit('lineCommand/updateTicket',{index:index,value:val});
        },
        toggleDoc:function(index){
            let val = this.docContent[index];
            val = !(val);
            this.$store.commit('lineCommand/updateDoc',{index:index,value:val});
        },
        // toggleCode:function(index){
        //     let val = this.codeContent[index];
        //     val = (val) ? false: true;
        //     this.$store.commit('lineCommand/updateCode',{index:index,value:val});
        // },
    }
}
</script>

<template>
    <div class="editorWrap">
        <div :id="editorId" style="width: 100%; height: 100%; float:left;"></div>
        <div id="ticketDisplay">
            <div v-for="(t, ti) in ticketContent" class="ticket_line" :style="rightGutter(ti)"
                 :class="{ 'ticket_line_on': t }" @click="toggleTicket(ti)" >
            </div>
        </div>
        <div id="docDisplay">
            <div v-for="(t, ti) in docContent" class="doc_line" :style="rightGutter(ti)"
                    :class="{ 'doc_line_on': t }" @click="toggleDoc(ti)"></div>
        </div>
        <!--<div id="codeDisplay">-->
            <!--<div class="code_line" v-for="(t, ti) in codeContent" :style="rightGutter(ti)"-->
                 <!--v-bind:class="{'code_line_on': t}" v-on:click="toggleCode(ti)"></div>-->
        <!--</div>-->
    </div>
</template>

<style>
    .editorWrap{
        position:relative;
    }
    #ticketDisplay{
        width: 18px;
        top: 0;
        right: 19px;
        /*right: 24px; //value when code is active */
        position: absolute;
    }
    .ticket_line {
        width:18px;
        height: 16px;
        content: "";
        display: block;
        float:right;
        position: absolute;
        top:0;
    }
    .ticket_line_on{
        background: #B4E6D6;
    }
    #docDisplay{
        width: 18px;
        top: 0;
        right: 0px;
        /*right: 12px; // value when code is active */
        position: absolute;
    }
    .doc_line {
        width:18px;
        height: 16px;
        content: "";
        display: block;
        position: absolute;
    }
    .doc_line_on{
        background: #9bd7e8;
    }
    #codeDisplay{
        width: 12px;
        top: 0;
        right: 0px;
        position: absolute;
    }
    .code_line {
        width:12px;
        height: 16px;
        content: "";
        display: block;
        position: absolute;
    }
    .code_line_on{
        background: #ade8c0;
    }
</style>

<style lang="scss" module>
@import '@design';


</style>
